//import Header from './ui/header.component';
import Navigate from './ui/navigate.component';

//import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@mui/material/styles';

//import {ConnectedRouter} from 'connected-react-router';
import { Parse } from 'parse';
import React from 'react';
import ContextualLifeCode from './experiences/ContextualLifeCode';
import InvitationLanding from './experiences/InvitationLanding';
import LifeTapExperience from './lifetaps/LifeTapExperience';
import ObjectWorkspace from './objects/ObjectWorkspace';
import StudioShell from './design/StudioShell';
import StudioOverview from './design/StudioOverview';
import ResourceWorkspace from './design/ResourceWorkspace';
import LocationSignalCreationWorkspace from './signals/LocationSignalCreationWorkspace';
import AddressAndBeaconCreationWorkspace from './signals/AddressAndBeaconCreationWorkspace';
import { activeTransport } from './api/lifetaggerApi';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import './App.css';
import { FlagsProvider } from 'react-feature-flags';
import Demo from './ui/demo.component';

import { Create as CreateTag } from './tags/tag.container';
import Analytics from './analytic/InsightsWorkspace';
import { All as Channels } from './channels/channel.container';
import { All as Help } from './help/help.container';
import { Update as UpdateUser } from './users/user.container';
import { All as Tags } from './tags/tag.container';
import { Update as UpdateTag } from './tags/tag.container';
import { Create as Session } from './sessions/session.container';
import { header as Header } from './ui/ui.container';
import Media from './design/MediaWorkspace';
import { AllByBeacon as QrTag } from './tags/tag.container';
import { CreateQr as CreateQrCode } from './beacons/beacon.container';
import { QrDetails as DetailsQr } from './beacons/beacon.container';
import { uiBlock as UiBlock } from './ui/ui.container';

const WebAddressSignalCreation = (props) => (
  <AddressAndBeaconCreationWorkspace {...props} mode="url" />
);

const BluetoothSignalCreation = (props) => (
  <AddressAndBeaconCreationWorkspace {...props} mode="ble" />
);
import { All as Integrations } from './connectors/connector.container';
import { ForgotPassword as PasswordReset } from './ui/ui.container';
import { CreateNFCTag as LifeTapCreate } from './nfc/nfc.new.component';
import { RegSpecial } from './users/refactored_user.new';
import UserProfileForm from './ui/userProfile.component';
import TagManager from 'react-gtm-module/dist/TagManager';
import UserNewLifeTap from './users/user.new.lifetap';
import { Snackbar } from 'react-redux-snackbar';

import ReactGA from 'react-ga';
import { UserNewStripeEmbed } from './users/user.new.stripe.embed';
import { initializeApp } from 'firebase/app';

import { getMessaging, onMessage } from 'firebase/messaging';
import ConferenceAndEvents from './ui/industryPages/conferenceEvents.component';
import ChurchEngagement from './ui/industryPages/churchEngagement.component';
import Cities from './ui/industryPages/Cities.component';
import Retail from './ui/industryPages/Retail.component';
import Restaurants from './ui/industryPages/Restaurants.component';

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_WEB_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
};

const firebaseIsConfigured = Boolean(
  config.apiKey && config.projectId && config.messagingSenderId && config.appId
);

try {
  const messaging = firebaseIsConfigured
    ? getMessaging(initializeApp(config))
    : null;
  if (messaging)
    onMessage(messaging, (payload) => {
      console.log('Message received. ', payload);
      // ...

      const { title, body, icon } = payload.notification;
      const link = payload.data?.url || payload.fcmOptions?.link;

      console.log('Link from notification:', link);

      // Show a custom notification with a clickable link
      showCustomNotification(title, body, icon, link);
    });
} catch (error) {
  console.log('Firebase messaging unavailable', error);
}

const showCustomNotification = (title, body, icon, link) => {
  const notificationElement = document.createElement('div');
  notificationElement.style.position = 'fixed';
  notificationElement.style.bottom = '20px';
  notificationElement.style.right = '20px';
  notificationElement.style.backgroundColor = '#333';
  notificationElement.style.color = '#fff';
  notificationElement.style.padding = '10px';
  notificationElement.style.borderRadius = '5px';
  notificationElement.innerHTML = `
    <img src="${icon}" style="width: 30px; height: 30px; margin-right: 10px;">
    <strong>${title}</strong><br>${body}
  `;

  notificationElement.onclick = () => {
    window.open(link, '_blank');
  };
  document.body.appendChild(notificationElement);

  setTimeout(() => {
    document.body.removeChild(notificationElement);
  }, 5000); // Remove after 5 seconds
};

const trackingId = process.env.REACT_APP_GOOGLE_ANALYTICS;
if (trackingId) ReactGA.initialize(trackingId);
const tagManagerArgs = {
  gtmId: 'GTM-KPJ2JG3',
};

TagManager.initialize(tagManagerArgs);

Parse.serverURL = process.env.REACT_APP_SERVER_LOCAL
  ? `${process.env.REACT_APP_SERVER_LOCAL}/parse`
  : process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/parse`
  : 'http://127.0.0.1:1337/parse';
Parse.initialize(
  process.env.REACT_APP_API_KEY || 'lifetagger-local-preview',
  process.env.REACT_APP_PARSE_JAVASCRIPT_KEY
);
window.Parse = Parse;
let hideNav = 'none';
let flags = [];

//hide drawer
if (Parse.User.current()) {
  hideNav = '';
  ReactGA.set({
    userId: Parse.User.current(),
  });

  const isPro =
    Parse.User.current().get('accountPlan') === 'plan_HHqLLnGbAL8lx2' ||
    Parse.User.current().get('accountPlan') === 'plan_HHqTYqPUkMuQA6' ||
    Parse.User.current().get('accountPlan') ===
      'price_1MrVzjG7JJ7XmqTHAw7xTK9v' ||
    Parse.User.current().get('accountPlan') ===
      'price_1MrVzjG7JJ7XmqTHzYFiky9v' ||
    Parse.User.current().get('accountPlan') ===
      'price_1Mm1bIG7JJ7XmqTHRzzOvG2k' ||
    Parse.User.current().get('accountPlan') === 'price_1Mm1bIG7JJ7XmqTHCPu61UnX'
      ? true
      : false;

  const isLite =
    Parse.User.current().get('accountPlan') ===
      'price_1MrVzxG7JJ7XmqTHxm88YaX4' ||
    Parse.User.current().get('accountPlan') ===
      'price_1MrVzxG7JJ7XmqTH5DZwKlt6' ||
    Parse.User.current().get('accountPlan') ===
      'price_1MlylRG7JJ7XmqTHDMfovWEA' ||
    Parse.User.current().get('accountPlan') === 'price_1MlylRG7JJ7XmqTHz2l0hxzv'
      ? true
      : false;

  const isPremium =
    Parse.User.current().get('accountPlan') ===
      'price_1Mm1eLG7JJ7XmqTHaXpMy6l9' ||
    Parse.User.current().get('accountPlan') ===
      'price_1Mm1eLG7JJ7XmqTHB1f1RXvq' ||
    Parse.User.current().get('accountPlan') ===
      'price_1MrVzYG7JJ7XmqTHjYJiKfdC' ||
    Parse.User.current().get('accountPlan') ===
      'price_1MrVzYG7JJ7XmqTH1B6oLJTj' ||
    Parse.User.current().get('status') === 'trialing'
      ? true
      : false;

  const isFree =
    (Parse.User.current().get('accountPlan') ===
      'price_1Qf1MbG7JJ7XmqTHrJw4F8aE' ||
      Parse.User.current().get('accountPlan') ===
        'price_1Qf1MbG7JJ7XmqTHrJw4F8aE' ||
      Parse.User.current().get('accountPlan') ===
        'price_1Qf1MbG7JJ7XmqTHrJw4F8aE' ||
      Parse.User.current().get('accountPlan') ===
        'price_1QuaOAG7JJ7XmqTHlfAIPlze') &&
    Parse.User.current().get('status') != 'trialing'
      ? true
      : false;

  const isBeta =
    process.env.REACT_APP_STAGE == 'DEV' ||
    process.env.REACT_APP_STAGE == 'DEVELOP' ||
    process.env.REACT_APP_STAGE == 'LOCAL'
      ? true
      : false;

  console.log('is beta?', isBeta);

  flags = [
    { name: 'pro', isActive: isPro },
    { name: 'beta', isActive: isBeta },
    { name: 'free', isActive: isFree },
    { name: 'lite', isActive: isLite },
    { name: 'premium', isActive: isPremium },
  ];

  if (window.pendo && typeof window.pendo.initialize === 'function') {
    window.pendo.initialize({
      visitor: {
        id: Parse.User.current().id,
        full_name: Parse.User.current().get('company'),
      },
      account: {
        id: Parse.User.current().id,
        is_paying: true,
        planLevel: Parse.User.current().get('accountPlan') || 'standard',
      },
    });
  }

  // Intercom identity verification hashes must be issued by a trusted server.
  // Never embed or use the signing secret in this browser bundle.
  if (typeof window.Intercom === 'function') {
    window.Intercom('boot', {
      app_id: 'jz4lhp2p',
      email: Parse.User.current().get('email'),
      name: Parse.User.current().get('name'),
      company: Parse.User.current().get('company'),
      user_id: Parse.User.current().id,
      created_at: Parse.User.current().get('createdAt'),
    });
  }
}

const useStyles = makeStyles((theme) => ({
  title: {
    flexGrow: 1,
  },
  toolbar: {
    [theme.breakpoints.down('sm')]: {
      diplay: 'none',
    },
    ...theme.mixins.toolbar,
  },

  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    color: '#fff',
    ...theme.mixins.toolbar,
  },
  appLogo: {
    marginTop: 20,
    borderRadius: '100%',
    borderColor: '#FFFFFF',
    borderStyle: 'solid',
    backgroundColor: '#FFFFFF',
    borderImageWidth: '45%',
    height: 40,
    width: 40,
    pointerEvents: 'none',
    align: 'left',
  },
  logoText: {
    color: 'white',
    position: 'relative',
    top: 14,
    display: 'inline',
    left: 8,
  },
  root: {
    height: '100%',
    display: 'flex',
  },
  notification: {
    color: '#ccc',
  },
  appBar: {
    marginLeft: '224px',
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - 224px)`,
    },
    color: '#000',
    background: theme.palette.background.default,
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: '224px',
      flexShrink: 0,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
    display: hideNav,
  },
  content: {
    flexGrow: 1,
    height: '100%',
    backgroundColor: '#F0F4FF',
    // padding: theme.spacing(3),
    //   backgroundColor: theme.palette.background.paper
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  login: {
    marginTop: 140,
    [theme.breakpoints.down('sm')]: {
      marginTop: 100,
    },
  },
  showView: {
    textAlign: 'left',
    verticalAlign: 'top',
    fontSize: '14pt',
    fontWeight: 'normal',
    fontFamily: 'Open Sans serif',
    marginTop: Parse.User.current() ? 60 : 0,
    padding: Parse.User.current() ? 20 : 0,
  },
  separator: {
    width: 1,
    height: 25,
    marginLeft: '1.5rem',
    marginRight: '1.5rem',
    borderLeft: '1px solid #000',
  },
}));

export default function App(props) {
  const { history } = props;
  window.dataLayer.push({
    event: 'pageview',
  });

  history.listen((location) => {
    ReactGA.set({ page: location.pathname });
  });

  const classes = useStyles();
  const theme = useTheme();
  const [profileMenuIsOpen, setProfileMenuIsOpen] = React.useState(false);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const currentPath = window.location.pathname;
  const studioWorkspace =
    Boolean(Parse.User.current()) &&
    /^\/(?:$|dashboard|objects|signals|media|analytics|user\/edit|integrations|help|qrcode|beacons|tags|tag\/edit|channels)/.test(
      currentPath
    );
  const modernWorkspace =
    studioWorkspace ||
    currentPath === '/objects' ||
    currentPath === '/preview/objects' ||
    currentPath === '/signals' ||
    currentPath.startsWith('/signals/');
  const externalExperience = /^\/(invitation|tap|experience)\//.test(
    currentPath
  );
  const fullBleedWorkspace = modernWorkspace || externalExperience;
  const openProfileMenu = () => setProfileMenuIsOpen(true);
  const closeProfileMenu = () => setProfileMenuIsOpen(false);
  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

  // Consumer LifeTaps must not inherit dashboard chrome, spacing or signup gates.
  if (/^\/tap\//.test(currentPath)) {
    return (
      <Router>
        <Switch>
          <Route path="/tap/:identifier" component={LifeTapExperience} />
        </Switch>
      </Router>
    );
  }

  return (
    <Router>
      <div className={classes.root}>
        {/* CSS Baseline */}
        <CssBaseline />
        {Parse.User.current() && !modernWorkspace && !externalExperience && (
          <Header
            profileMenuIsOpen={profileMenuIsOpen}
            handleDrawerToggle={handleDrawerToggle}
            openProfileMenu={openProfileMenu}
            closeProfileMenu={closeProfileMenu}
            classes={classes}
          />
        )}

        {Parse.User.current() && !modernWorkspace && !externalExperience && (
          <Navigate
            sentInClasses={classes}
            theme={theme}
            history={history}
            handleDrawerToggle={handleDrawerToggle}
            mobileOpen={mobileOpen}
          />
        )}

        {/* Main content */}
        <main
          className={classes.content}
          color={'secondary'}
          style={
            fullBleedWorkspace ? { backgroundColor: '#faf9f7' } : undefined
          }
        >
          <div
            className={fullBleedWorkspace ? undefined : classes.showView}
            style={fullBleedWorkspace ? { width: '100%' } : undefined}
          >
            <Snackbar />
            <UiBlock />
            {React.createElement(
              studioWorkspace ? StudioShell : React.Fragment,
              null,
              <Switch>
                <Route exact path="/login" component={Session} />
                {activeTransport === 'mock' && (
                  <Route path="/preview/objects" component={ObjectWorkspace} />
                )}
                <Route
                  path="/experience/push/:token"
                  component={ContextualLifeCode}
                />
                <Route
                  path="/experience/lifecode/:identifier"
                  component={ContextualLifeCode}
                />
                <Route
                  path="/invitation/:token"
                  component={InvitationLanding}
                />
                <Route path="/qrtags/:id" component={QrTag} />
                <Route path="/push/:id" component={QrTag} />
                <Route path="/ltcard/:id" component={UserProfileForm} />
                <PrivateRoute exact path="/" component={StudioOverview} />
                <PrivateRoute path="/dashboard" component={StudioOverview} />
                <PrivateRoute exact path="/tags" component={Tags} />
                <PrivateRoute
                  exact
                  path="/objects"
                  component={ObjectWorkspace}
                />
                <PrivateRoute
                  exact
                  path="/signals"
                  component={ResourceWorkspace}
                />
                <PrivateRoute
                  exact
                  path="/signals/location/create"
                  component={LocationSignalCreationWorkspace}
                />
                <PrivateRoute
                  exact
                  path="/signals/web/create"
                  component={WebAddressSignalCreation}
                />
                <PrivateRoute
                  exact
                  path="/signals/bluetooth/create"
                  component={BluetoothSignalCreation}
                />
                <PrivateRoute path="/analytics" component={Analytics} />
                <PrivateRoute exact path="/tags/create" component={CreateTag} />
                <PrivateRoute exact path="/media" component={Media} />
                <PrivateRoute path="/channels" component={Channels} />
                <PrivateRoute
                  exact
                  path="/qrcode"
                  component={ResourceWorkspace}
                />
                <PrivateRoute
                  exact
                  path="/qrcode/create"
                  component={CreateQrCode}
                />
                <PrivateRoute
                  path="/qrcode/details/:id"
                  component={DetailsQr}
                />
                <PrivateRoute path="/tag/edit/:id" component={UpdateTag} />
                <PrivateRoute
                  exact
                  path="/beacon/create"
                  component={BluetoothSignalCreation}
                />
                <PrivateRoute path="/help" component={Help} />
                <PrivateRoute path="/user/edit" component={UpdateUser} />
                <PrivateRoute
                  path="/beacons"
                  component={() => <ResourceWorkspace kind="ble" />}
                />
                {/* <Flags authorizedFlags={['beta']}> */}
                <PrivateRoute path="/integrations" component={Integrations} />
                {/* </Flags> */}
                <Route path="/register" component={UserNewStripeEmbed} />
                <Route path="/lifetapCreate" component={LifeTapCreate} />
                <Route path="/lifetapregistration" component={UserNewLifeTap} />
                <Route path="/resetpassword" component={PasswordReset} />
                <Route path="/demo" component={Demo} />
                <Route path="/regspecial" component={RegSpecial} />
                <Route
                  path="/conferenceevents"
                  component={ConferenceAndEvents}
                />
                <Route path="/churchengagement" component={ChurchEngagement} />
                <Route path="/cities" component={Cities} />
                <Route path="/retail" component={Retail} />
                <Route path="/restaurants" component={Restaurants} />

                {/* <Route path="/register" component={createUser}/> */}
              </Switch>
            )}
          </div>
        </main>
      </div>
    </Router>
  );
}

function PrivateRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        Parse.User.current() ? (
          <FlagsProvider value={flags}>
            <Component {...props} />
          </FlagsProvider>
        ) : (
          <Session {...props} />
        )
      }
    />
  );
}
